/**
 * Returns a new Date object by adding a specified number of days to a given start date.
 *
 * @param startDate - The starting Date object.
 * @param daysToAdd - The number of days to add.
 * @returns A new Date object with the days added.
 */

export const getRangeEndDate = (startDate: Date, daysToAdd: number) => {
  const msPerDay = 1000 * 60 * 60 * 24;

  return new Date(startDate.getTime() + daysToAdd * msPerDay);
};
